








import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Contracts from "@/components/templates/Contracts/index.vue";
import snackbar from "@/shared/snackbar";
import testData from "@/shared/testData.js";

@Component({
  components: { Contracts },
})
export default class ContractsView extends Vue {
  private currentSource: any = {};

  private mounted() {
    this.$store.dispatch("contract/getCustomer");
  }

  private contractInfo() {
    const { subscriptions, product, sources } = this.$store.state.contract.customer;
    const source = (sources && sources.data) ? sources.data[0] : {};

    if (subscriptions) {
      const subscription = subscriptions.data[0];
      return [
        { label: "ご契約中のサービス", text: product.name },
        { label: "課金単位", text: product.unit_label },
        { label: "お支払い単位", text: subscription.plan.nickname },
        { label: "お支払い方法", text: subscription.billing === "charge_automatically" ? "クレジットカード(自動引落し)" : "メールによる請求書の送付"},
      ];
    } else {
      return [];
    }
  }

  private async handleOnSelectYearChange(year: string) {
    try {
      const result =  await this.$store.dispatch("contract/getInvoices", year);
    } catch (err) {
      console.log(err);
      snackbar.error(this, { message: `請求情報の取得に失敗しました。:${err}`});
    }
  }

}
